import React, { useEffect } from 'react'
import ConversationSection from '../../Components/WebChat/ConversationSection'
import { formatUserIdToJid } from '../../Helpers/Chat/ChatHelper';
import { encryptAndStoreInLocalStorage } from '../../Helpers/Chat/webChatEncryptDecrypt';
import { constructedActiveChatData } from '../../Helpers/Utility';
import { addActiveChatData } from '../../Redux/feature/activeChatDataSlice';
import { store } from '../../Redux/store';
import ringingTone from "../../Components/WebCall/ringingtone";
import outgoingRinging from "../../Components/WebCall/outgoingRingingBase64"
import busySignal from '../../Components/WebCall/busySignalBase64';
import notificationSound from '../../Helpers/Browser/notificationBase64';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import WebChatMediaPreview from '../../Components/WebChat/ConversationSection/Conversation/WebChatMediaPreview';
import useWindowSize from '../../hooks/useWindowSize';
import browserTab from '../../Helpers/Browser/BrowserTab';
import browserNotify from '../../Helpers/Browser/BrowserNotify';
import SDK from '../../SDK';
import { addRecentChat } from '../../Redux/feature/recentChatDataSlice';

export const CustomConversation = (props) => {
    const { darkTheme = "", enableDeviceSize = false ,isCallEnabled, sdkInitial = false } = props;
    const  mirrorflyInitials = sdkInitial ? sdkInitial : useSelector(state => state.mirrorflyInitial?.data);
    console.log(mirrorflyInitials , "mirrorflyInitials");
    const singleChatSelectedData = useSelector((state) => state.singleChatSelectedMediaData);
    const [showMessageinfo, setshowMessageinfo] = React.useState(false);
    const [getRecentChatDataRes, setRecentChatDataRes] = React.useState({})
    const [hideCallScreen, setHideCallScreen] = React.useState(false);
    const [getisShowPreviewMedia, setisShowPreviewMedia] = React.useState(false);
    const [enableMobileView, setEnableMobileView] = React.useState(false)
    const { data : singleChatSelectedMedia = {}} = singleChatSelectedData
    const selectedMedia = singleChatSelectedMedia;
    const openStatus = true;
    const windowSize = useWindowSize();
    
    React.useEffect(()=>{
        console.log(mirrorflyInitials, props , "--- inside changeActiveChatData 1 --- ");
        async function changeActiveChatData() {
            console.log(mirrorflyInitials , "userJid inside changeActiveChatData 1");
            if(mirrorflyInitials){
                const recentChatsRes = await SDK.getRecentChats();
                console.log(recentChatsRes, "recentChatsRes 2");
                if (recentChatsRes && recentChatsRes.statusCode === 200) {
                    store.dispatch(addRecentChat(recentChatsRes.data));
                    setRecentChatDataRes(recentChatsRes.data);
                    console.log(recentChatsRes, "recentChatsRes 3");

                    console.log(mirrorflyInitials , "userJid inside 2");
                    const userJid = await formatUserIdToJid(props.userId,props.chatType);
                    console.log(userJid , "userJid inside 3");
                    if(!userJid){return}
                    const activeChatData = await constructedActiveChatData(userJid,props.chatType)
                    console.log(activeChatData , "userJid post return activeChatData 4");
    
                    store.dispatch(addActiveChatData(activeChatData));
                }
            }
        }
        changeActiveChatData()
    },[mirrorflyInitials,props])

    React.useEffect(()=>{
        window.ringingTone = new Audio(ringingTone)
        window.outgoingRingTone = new Audio(outgoingRinging)
        window.busySignal = new Audio(busySignal)
        window.notifySound = new Audio(notificationSound)
        browserTab.init();
        browserNotify.init();
        if(document.getElementById("mf-root-Parent").parentElement.offsetWidth < 1025){
          setEnableMobileView(true);
          if(enableDeviceSize === true){
            customResizeMw()
          }
        }
      },[])

    React.useEffect(()=>{
        if(singleChatSelectedData.id && singleChatSelectedData.id !== null){
            setisShowPreviewMedia(true)}
        },[singleChatSelectedData.id])
        
        const customResize = () => {
            document.getElementById('mirrorFlyRoot').style.height = window.innerHeight + "px";
            document.getElementById('mirrorFlyRoot').style.width = window.innerWidth + "px";
            document.getElementById('mirrorFlyRoot').style.maxWidth = "100%";
        }
        const customResizeMw = () => {
            document.getElementById('mirrorFlyRoot').style.height = window.innerHeight + "px";
            document.getElementById('mirrorFlyRoot').style.width = "100%";
            document.getElementById('mirrorFlyRoot').style.maxWidth = window.innerWidth + "px";
        }

    React.useEffect(()=>{
        if(document.getElementById("mf-root-Parent").parentElement.offsetWidth < 1025){
            setEnableMobileView(true)
        } else {
            setEnableMobileView(false)
        }
    },[windowSize])

    React.useEffect(()=>{
        if(document.getElementById("mf-root-Parent").parentElement.offsetWidth > 1024){
            window.addEventListener('resize', () => {
            if(enableDeviceSize === true){
                customResize();
            }
            });
            window.removeEventListener('resize', customResizeMw);
        }
        else {
        window.addEventListener('resize', () => {
            if(enableDeviceSize === true){
            customResizeMw();
            }
        });
        window.removeEventListener('resize', customResize);
        }
    },[])
    
    const handleShowCallScreen = () => {
        encryptAndStoreInLocalStorage("hideCallScreen", false);
        setHideCallScreen(false);
    };
    const messageInfoShow = (valueToShowMsgInfo = false) => {  
        setshowMessageinfo (valueToShowMsgInfo)
    };
    const handleMediaShow = (data, state = false) => {
        setisShowPreviewMedia(state);
    };

    const handleMediaClose = () => {
        setisShowPreviewMedia(false)
    };
    // const handleRecentChatData = async () => {
    //     console.log("recentChatsRes 1 called");
    //     const recentChatsRes = await SDK.getRecentChats();
    //     console.log(recentChatsRes, "recentChatsRes 2");
    //     if (recentChatsRes && recentChatsRes.statusCode === 200) {
    //         store.dispatch(addRecentChat(recentChatsRes.data));
    //         setRecentChatDataRes(recentChatsRes.data);
    //         console.log(recentChatsRes, "recentChatsRes 3");
    //     }
    // }

    // useEffect(() => {
    //     handleRecentChatData();
    // },[props, ]);
    
    return (
        <>
    <div id="mirrorFlyRoot" className={`mirrorfly-root ${ enableMobileView === true ? " mobileView " : " " }`}>
      <div className={` ${darkTheme ? " dark-theme-active " : " "} boxLayout`}>
        <div className="container containerLayout" id="container">

        {getisShowPreviewMedia && (
            <WebChatMediaPreview
              jid={selectedMedia.jid}
              chatType={selectedMedia.chatType}
              selectedMessageData={selectedMedia.selectedMessageData}
              handleMediaClose={(e) => handleMediaClose()}
            />
          )}
            {  mirrorflyInitials &&
                <ConversationSection
                    handleMediaShow={handleMediaShow} 
                    showMessageinfo = {showMessageinfo} 
                    showonGoingcallDuration={hideCallScreen}
                    openStatus={openStatus}
                    handleShowCallScreen={handleShowCallScreen}
                    messageInfoShow = {messageInfoShow}
                    isCallEnabled = {isCallEnabled}
                />  
            }
                </div>
      </div>
      <ToastContainer position="top-right" />

      </div>

        </>
    )
}